// import React, { useState, useEffect, useMemo } from 'react';
// import './Setting.css'; // Ensure your CSS file is correctly linked for styling
// import { getWithTokenAPI } from '../../util/Api';
// import { useNavigate } from 'react-router-dom';
// import Dashboardmy from '../Dashboard-component/Dashboard'; // Assuming this is your sidebar/dashboard layout
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { useSelector } from 'react-redux';

// // Status constants for consistent comparison
// const STATUS = {
//     PAID: 'PAID',
//     PENDING: 'PENDING',
//     NOT_PAID: 'NOT PAID'
// };

// const Subscription = () => {
//     const navigate = useNavigate();
//     const userId = useSelector(state => state.auth?.auth?._id);
//     const accessToken = useSelector((state) => state.auth?.auth?.access_token);

//     const [loading, setLoading] = useState(true);
//     const [subscriptions, setSubscriptions] = useState([]);
//     const [error, setError] = useState(null);

//     // Pagination states
//     const [currentPage, setCurrentPage] = useState(1);
//     const itemsPerPage = 5; // Display 5 data per page

//     useEffect(() => {
//         const fetchSubscriptions = async () => {
//             if (!userId || !accessToken) {
//                 setLoading(false);
//                 setError("User not logged in or access token missing.");
//                 toast.error("Please log in to view subscriptions.");
//                 return;
//             }

//             try {
//                 setLoading(true);
//                 setError(null);
//                 const response = await getWithTokenAPI(accessToken, `/subscription/find-all?user_id=${userId}`);

//                 if (response.statusCode === 200 && response.data && Array.isArray(response.data.subscriber)) {
//                     setSubscriptions(response.data.subscriber);
//                 } else if (response.statusCode === 200 && response.data && !Array.isArray(response.data.subscriber)) {
//                     setSubscriptions([]);
//                     toast.info(response.message || "No subscriptions found for your account.");
//                 } else {
//                     setError(response.message || "Failed to fetch subscriptions.");
//                     toast.error(response.message || "Failed to fetch subscriptions.");
//                 }
//             } catch (err) {
//                 console.error("Error fetching subscriptions:", err);
//                 setError("An error occurred while fetching subscriptions.");
//                 toast.error("An error occurred while fetching subscriptions.");
//                 if (err.response && err.response.status === 401) {
//                     navigate('/login');
//                 }
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchSubscriptions();
//     }, [userId, accessToken, navigate]);

//     // Helper to determine if any subscription is 'PAID' to show date columns
//     const showDateColumns = useMemo(() => {
//         // Use .some() to check if at least one subscription has PAID status
//         return subscriptions.some(sub => sub?.paid_status?.trim().toUpperCase() === STATUS.PAID);
//     }, [subscriptions]);

//     // Helper to get status text and colors based on your new logic
//     const getDisplayStatusAndColors = (paidStatus) => {
//         const status = paidStatus?.trim().toUpperCase(); // Convert to uppercase for consistent comparison

//         switch (status) {
//             case STATUS.PAID:
//                 return { text: 'Paid', style: { backgroundColor: '#00b207', color: '#fff' } }; // Green for Paid
//             case STATUS.NOT_PAID:
//                 return { text: 'Failed', style: { backgroundColor: '#e74c3c', color: '#fff' } }; // Red for NOT PAID (now "Failed")
//             case STATUS.PENDING:
//                 return { text: 'Timed Out', style: { backgroundColor: '#f39c12', color: '#fff' } }; // Orange for PENDING (now "Timed Out")
//             default:
//                 return { text: 'Unknown', style: { backgroundColor: '#DCDCDC', color: '#4F4F4F' } }; // Grey for unknown
//         }
//     };

//     // Pagination Logic
//     const totalPages = Math.ceil(subscriptions.length / itemsPerPage);
//     const indexOfLastItem = currentPage * itemsPerPage;
//     const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//     const currentItems = subscriptions.slice(indexOfFirstItem, indexOfLastItem);

//     const paginate = (pageNumber) => setCurrentPage(pageNumber);

//     const renderPaginationButtons = () => {
//         const pageNumbers = [];
//         // Ensure that only relevant page numbers are shown for better UX
//         const maxPageButtons = 5; // e.g., show 5 page buttons at a time
//         let startPage = Math.max(1, currentPage - Math.floor(maxPageButtons / 2));
//         let endPage = Math.min(totalPages, startPage + maxPageButtons - 1);

//         if (endPage - startPage + 1 < maxPageButtons) {
//             startPage = Math.max(1, endPage - maxPageButtons + 1);
//         }

//         for (let i = startPage; i <= endPage; i++) {
//             pageNumbers.push(
//                 <button
//                     key={i}
//                     onClick={() => paginate(i)}
//                     className={`pagination-button ${currentPage === i ? 'active' : ''}`}
//                 >
//                     {i}
//                 </button>
//             );
//         }
//         return pageNumbers;
//     };


//     return (
//         <>
//             <ToastContainer autoClose={3000} />
//             <div className='show-contents'>
//                 <Dashboardmy /> {/* Your Dashboard component */}
//                 <div className="subscription-container">
//                     <h4 className="subscription-title">My Subscriptions</h4>
//                     {loading && <div className="loading-message">Loading subscriptions...</div>}
//                     {error && <div className="error-message">{error}</div>}
//                     {!loading && !error && subscriptions.length === 0 && (
//                         <div className="no-subscriptions-message">You don't have any subscriptions yet.</div>
//                     )}
//                     {!loading && !error && subscriptions.length > 0 && (
//                         <>
//                             <div className="table-responsive subscription-table-responsive">
//                                 <table className="table table-hover table-striped subscription-table">
//                                     <thead>
//                                         <tr>
//                                             <th>ID</th>
//                                             <th>Amount</th>
//                                             <th>Tax</th>
//                                             <th>Total</th>
//                                             <th>Status</th>
//                                             {showDateColumns && (
//                                                 <>
//                                                     <th>Start Date</th>
//                                                     <th>End Date</th>
//                                                     <th>Remaining Days</th>
//                                                 </>
//                                             )}
//                                         </tr>
//                                     </thead>
//                                     <tbody>
//                                         {currentItems.map((sub) => {
//                                             const { text: displayStatusText, style: statusStyle } = getDisplayStatusAndColors(sub.paid_status);
//                                             // Ensure this comparison also uses toUpperCase() for consistency
//                                             const isActiveSubscription = sub?.paid_status?.trim().toUpperCase() === STATUS.PAID;

//                                             return (
//                                                 <tr key={sub._id}>
//                                                     <td data-label="ID">#{sub._id.substring(sub._id.length - 4)}</td>
//                                                     <td data-label="Amount">KSh {sub.amount ? sub.amount.toFixed(2) : 'N/A'}</td>
//                                                     <td data-label="Tax">KSh {sub.tax_amount ? sub.tax_amount.toFixed(2) : 'N/A'}</td>
//                                                     <td data-label="Total"><span className="total-price-value">KSh {sub.total_amount ? sub.total_amount.toFixed(2) : 'N/A'}</span></td>
//                                                     <td data-label="Status">
//                                                         <span className="subscription-status-pill" style={statusStyle}>
//                                                             {displayStatusText}
//                                                         </span>
//                                                     </td>
//                                                     {showDateColumns && (
//                                                         <>
//                                                             <td data-label="Start Date">{isActiveSubscription && sub.start_date ? new Date(sub.start_date).toLocaleDateString() : 'N/A'}</td>
//                                                             <td data-label="End Date">{isActiveSubscription && sub.end_date ? new Date(sub.end_date).toLocaleDateString() : 'N/A'}</td>
//                                                             <td data-label="Remaining Days">{isActiveSubscription && sub.remaining_days !== undefined ? sub.remaining_days : 'N/A'}</td>
//                                                         </>
//                                                     )}
//                                                 </tr>
//                                             );
//                                         })}
//                                     </tbody>
//                                 </table>
//                             </div>

//                             {/* Pagination controls */}
//                             {totalPages > 1 && (
//                                 <div className="pagination-controls">
//                                     <button
//                                         onClick={() => paginate(currentPage - 1)}
//                                         disabled={currentPage === 1}
//                                         className="pagination-button"
//                                     >
//                                         Previous
//                                     </button>
//                                     {renderPaginationButtons()}
//                                     <button
//                                         onClick={() => paginate(currentPage + 1)}
//                                         disabled={currentPage === totalPages}
//                                         className="pagination-button"
//                                     >
//                                         Next
//                                     </button>
//                                 </div>
//                             )}
//                         </>
//                     )}
//                 </div>
//             </div>
//         </>
//     );
// };

// export default Subscription;

import React, { useState, useEffect, useMemo } from 'react';
import './Setting.css'; // Ensure your CSS file is correctly linked for styling
import { getWithTokenAPI } from '../../util/Api';
import { useNavigate } from 'react-router-dom';
import Dashboardmy from '../Dashboard-component/Dashboard'; // Assuming this is your sidebar/dashboard layout
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useSelector } from 'react-redux';

// Status constants defined in lowercase for consistent comparison
const STATUS = {
    PAID: 'paid',
    PENDING: 'pending',
    NOT_PAID: 'not paid'
};

const Subscription = () => {
    const navigate = useNavigate();
    const userId = useSelector(state => state.auth?.auth?._id);
    const accessToken = useSelector((state) => state.auth?.auth?.access_token);

    const [loading, setLoading] = useState(true);
    const [subscriptions, setSubscriptions] = useState([]);
    const [error, setError] = useState(null);

    // Pagination states
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 5; // Display 5 data per page

    useEffect(() => {
        const fetchSubscriptions = async () => {
            if (!userId || !accessToken) {
                setLoading(false);
                setError("User not logged in or access token missing.");
                toast.error("Please log in to view subscriptions.");
                return;
            }

            try {
                setLoading(true);
                setError(null);
                const response = await getWithTokenAPI(accessToken, `/subscription/find-all?user_id=${userId}`);

                if (response.statusCode === 200 && response.data && Array.isArray(response.data.subscriber)) {
                    setSubscriptions(response.data.subscriber);
                } else if (response.statusCode === 200 && response.data && !Array.isArray(response.data.subscriber)) {
                    setSubscriptions([]);
                    toast.info(response.message || "No subscriptions found for your account.");
                } else {
                    setError(response.message || "Failed to fetch subscriptions.");
                    toast.error(response.message || "Failed to fetch subscriptions.");
                }
            } catch (err) {
                console.error("Error fetching subscriptions:", err);
                setError("An error occurred while fetching subscriptions.");
                toast.error("An error occurred while fetching subscriptions.");
                if (err.response && err.response.status === 401) {
                    navigate('/login');
                }
            } finally {
                setLoading(false);
            }
        };

        fetchSubscriptions();
    }, [userId, accessToken, navigate]);

    // Helper to determine if any subscription is 'PAID' to show date columns
    const showDateColumns = useMemo(() => {
        // Convert sub.paid_status to lowercase for robust comparison
        return subscriptions.some(sub => sub?.paid_status?.trim().toLowerCase() === STATUS.PAID);
    }, [subscriptions]);

    // Helper to get status text and colors based on your new logic
    const getDisplayStatusAndColors = (paidStatus) => {
        // Convert the incoming paidStatus to lowercase for robust comparison
        const normalizedStatus = paidStatus?.trim().toLowerCase();

        switch (normalizedStatus) {
            case STATUS.PAID:
                return { text: 'Paid', style: { backgroundColor: '#00b207', color: '#fff' } }; // Green for Paid
            case STATUS.NOT_PAID:
                return { text: 'Failed', style: { backgroundColor: '#e74c3c', color: '#fff' } }; // Red for NOT PAID (now "Failed")
            case STATUS.PENDING:
                return { text: 'Timed Out', style: { backgroundColor: '#f39c12', color: '#fff' } }; // Orange for PENDING (now "Timed Out")
            default:
                return { text: 'Unknown', style: { backgroundColor: '#DCDCDC', color: '#4F4F4F' } }; // Grey for unknown
        }
    };

    // Helper function to format date and time
    const formatDateTime = (dateString) => {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        // Options for formatting date and time
        const options = {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true // Use 12-hour format with AM/PM
        };
        return date.toLocaleString(undefined, options);
    };

    // Pagination Logic
    const totalPages = Math.ceil(subscriptions.length / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = subscriptions.slice(indexOfFirstItem, indexOfLastItem);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const renderPaginationButtons = () => {
        const pageNumbers = [];
        // Ensure that only relevant page numbers are shown for better UX
        const maxPageButtons = 5; // e.g., show 5 page buttons at a time
        let startPage = Math.max(1, currentPage - Math.floor(maxPageButtons / 2));
        let endPage = Math.min(totalPages, startPage + maxPageButtons - 1);

        if (endPage - startPage + 1 < maxPageButtons) {
            startPage = Math.max(1, endPage - maxPageButtons + 1);
        }

        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(
                <button
                    key={i}
                    onClick={() => paginate(i)}
                    className={`pagination-button ${currentPage === i ? 'active' : ''}`}
                >
                    {i}
                </button>
            );
        }
        return pageNumbers;
    };


    return (
        <>
            <ToastContainer autoClose={3000} />
            <div className='show-contents'>
                <Dashboardmy /> {/* Your Dashboard component */}
                <div className="subscription-container">
                    <h4 className="subscription-title">My Subscriptions</h4>
                    {loading && <div className="loading-message">Loading subscriptions...</div>}
                    {error && <div className="error-message">{error}</div>}
                    {!loading && !error && subscriptions.length === 0 && (
                        <div className="no-subscriptions-message">You don't have any subscriptions yet.</div>
                    )}
                    {!loading && !error && subscriptions.length > 0 && (
                        <>
                            <div className="table-responsive subscription-table-responsive">
                                <table className="table table-hover table-striped subscription-table">
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Amount</th>
                                            <th>Tax</th>
                                            <th>Total</th>
                                            <th>Status</th>
                                            <th>Created At</th> {/* New header column */}
                                            {showDateColumns && (
                                                <>
                                                    <th>Start Date</th>
                                                    <th>End Date</th>
                                                    <th>Remaining Days</th>
                                                </>
                                            )}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentItems.map((sub) => {
                                            const { text: displayStatusText, style: statusStyle } = getDisplayStatusAndColors(sub.paid_status);
                                            // Convert sub.paid_status to lowercase for robust comparison
                                            const isActiveSubscription = sub?.paid_status?.trim().toLowerCase() === STATUS.PAID;

                                            return (
                                                <tr key={sub._id}>
                                                    <td data-label="ID">#{sub._id.substring(sub._id.length - 4)}</td>
                                                    <td data-label="Amount">KSh {sub.amount ? sub.amount.toFixed(2) : 'N/A'}</td>
                                                    <td data-label="Tax">KSh {sub.tax_amount ? sub.tax_amount.toFixed(2) : 'N/A'}</td>
                                                    <td data-label="Total"><span className="total-price-value">KSh {sub.total_amount ? sub.total_amount.toFixed(2) : 'N/A'}</span></td>
                                                    <td data-label="Status">
                                                        <span className="subscription-status-pill" style={statusStyle}>
                                                            {displayStatusText}
                                                        </span>
                                                    </td>
                                                    {/* New data cell for Created At */}
                                                    <td data-label="Created At">{formatDateTime(sub.createdAt)}</td>
                                                    {showDateColumns && (
                                                        <>
                                                            <td data-label="Start Date">{isActiveSubscription && sub.start_date ? new Date(sub.start_date).toLocaleDateString() : 'N/A'}</td>
                                                            <td data-label="End Date">{isActiveSubscription && sub.end_date ? new Date(sub.end_date).toLocaleDateString() : 'N/A'}</td>
                                                            <td data-label="Remaining Days">{isActiveSubscription && sub.remaining_days !== undefined ? sub.remaining_days : 'N/A'}</td>
                                                        </>
                                                    )}
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>

                            {/* Pagination controls */}
                            {totalPages > 1 && (
                                <div className="pagination-controls">
                                    <button
                                        onClick={() => paginate(currentPage - 1)}
                                        disabled={currentPage === 1}
                                        className="pagination-button"
                                    >
                                        Previous
                                    </button>
                                    {renderPaginationButtons()}
                                    <button
                                        onClick={() => paginate(currentPage + 1)}
                                        disabled={currentPage === totalPages}
                                        className="pagination-button"
                                    >
                                        Next
                                    </button>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
        </>
    );
};

export default Subscription;